import type { App } from 'vue';

import { useAuthenticationStore } from 'src/stores/authentication';
import { useUserInterfaceSettingsStore } from 'src/stores/userInterfaceSettings';

import useAuthentication from 'src/filters/authentication';

import { applyDarkMode } from 'src/util/theme/applyDarkMode';

export async function bootTheming({ app }: { app: App<Element> }): Promise<void> {
	const { initialize } = useAuthentication();
	const authenticationStore = useAuthenticationStore();
	const userInterfaceSettingsStore = useUserInterfaceSettingsStore();

	return new Promise<void>((resolve) => {
		initialize();
		applyDarkMode(userInterfaceSettingsStore.themeMode);

		if (!authenticationStore.loggedIn) {
			resolve();
			return;
		}

		const queryStore = app.config.globalProperties.$queryStore;

		Promise.allSettled([
			userInterfaceSettingsStore.fetchEditorStandardFont({
				queryStore: queryStore,
			}),
			userInterfaceSettingsStore.fetchUserPreferences({
				queryStore: queryStore,
			}),
		])
			.then(() => {
				resolve();
			})
			.catch(() => {
				resolve();
			});
	});
}
